import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import aiAgentReducer from './aiAgentSlice';
import matchReducer from './matchSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    aiAgent: aiAgentReducer,
    match: matchReducer,
  },
});

export default store;